import type {
  Editor,
  InputDescription,
  ListConfig,
  ValueConfig,
  ValueConfig_V,
} from "@smartsuite/automation-engine-api";
import { ValueDescription_T } from "@smartsuite/automation-engine-api";
import {
  EmptyButton,
  EmptyButtonSize,
  Modal,
  ModalFooter,
  RoundButton,
  roundButtonStylesMedium,
} from "@smartsuite/react-ui/lib";
import { observer } from "mobx-react-lite";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRootStore } from "../../../../../../../../../stores/hooks";
import type {
  ActionCandidate,
  InputCandidate,
} from "../../../../../../../../../types/candidate";
import { Text } from "../style";
import {
  defaultDescription,
  defaultInput,
  defaultPropertyKeyInput,
  emptyValueByType,
} from "../utils/inputs";
import { options } from "../utils/options";
import { getIcon } from "../utils/render-options";
import { withInstruction } from "../with-instructions";
import { PropertyModal } from "./property-modal";
import * as S from "./style";

export const ModalSelectField = observer<{
  onChange: () => void;
  onClose: () => void;
  description: InputDescription;
  onlyStructure?: boolean;
  action?: ActionCandidate;
  listConfig?: ListConfig;
  excessDepth?: boolean;
  keyValueConfig?: ValueConfig;
}>(
  ({
    onChange,
    onClose,
    description,
    onlyStructure,
    action,
    listConfig,
    excessDepth,
    keyValueConfig,
  }) => {
    const [bodyType, setBodyType] = useState<string>("");

    const [firstRender, setFirstRender] = useState<boolean>(true);

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
      const handleClickOutside = (event: Event): void => {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          onClose();
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);

    const onSelectedOptionChange = (
      type: string,
      firstRender: boolean,
    ): void => {
      setBodyType(type);
      if (firstRender) {
        setFirstRender(false);
      }
    };

    return (
      <>
        {firstRender ? (
          <>
            <S.GlobalStyle />
            <Modal
              ref={ref}
              withoutHat={true}
              withoutHeader={true}
              className="flat-modal-items"
              size="XS"
              bodyStyles={{ borderRadius: "8px" }}
              children={
                <S.ModalBodyWrapper isFirstRender={true}>
                  <S.ModalTitle>JSON</S.ModalTitle>
                  {options(
                    excessDepth,
                    onlyStructure && listConfig !== undefined,
                    !onlyStructure && keyValueConfig !== undefined,
                  ).map((option) => (
                    <S.ModalItem
                      key={option.value}
                      onClick={() => onSelectedOptionChange(option.value, true)}
                    >
                      {getIcon(option.iconName)}
                      <Text className="modal-item-text"> {option.label}</Text>
                    </S.ModalItem>
                  ))}
                </S.ModalBodyWrapper>
              }
            />
          </>
        ) : (
          <PropertyModal
            onChange={onChange}
            onClose={onClose}
            description={description}
            onlyStructure={onlyStructure}
            action={action}
            listConfig={listConfig}
            excessDepth={excessDepth}
            bodyType={bodyType}
            keyValueConfig={keyValueConfig}
          />
        )}
      </>
    );
  },
);
